import React from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  path: string; // e.g. "/" or "/products"
  ogImage?: string;
}

const BASE_URL = 'https://touchevent.site';

/**
 * Per-route SEO meta tags.
 * React 19 natively hoists <title>, <meta>, <link> from components into <head>.
 */
const SEOHead: React.FC<SEOHeadProps> = ({ title, description, path, ogImage }) => {
  const canonicalUrl = `${BASE_URL}${path === '/' ? '/' : path}`;
  const image = ogImage || `${BASE_URL}/assets/site_logo.png`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="he_IL" />
      <meta property="og:site_name" content="Touch Event" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </>
  );
};

export default SEOHead;
